import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress ResizeObserver loop errors (harmless, caused by Framer Motion / TradingView)
// window.onerror returning true prevents the CRA dev overlay from showing it
window.onerror = function (message) {
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) return true;
};
const suppressResizeObserver = (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    if (e.preventDefault) e.preventDefault();
    return false;
  }
};
window.addEventListener('error', suppressResizeObserver, true);
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver')) {
    e.preventDefault();
  }
});

// Also patch ResizeObserver to prevent these errors entirely
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => {
        try { callback(entries, observer); } catch (e) { /* suppress */ }
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
